import { combineReducers } from "redux";
import { Reducer } from "redux-actions";
// import { createEpicMiddleware } from "redux-observable";
import Localization from "../Utils/Localization";
// import { Epics } from "./Epics";

import {
  Store as BwtkStore,
  Injectable,
  CommonFeatures,
  LocalizationState,
} from "bwtk";
const { BaseStore } = CommonFeatures;

@Injectable
export default class Store extends BaseStore<State> {
  constructor(
    store: BwtkStore,
    // private epics: Epics,
    private localization: Localization
  ) {
    super(store);
  }

  get reducer() {
    return combineReducers<State, any>({
      localization: this.localization.createReducer() as Reducer<
        LocalizationState,
        LocalizationState
      >
    });
  }

  // get middlewares() {
  //   return [createEpicMiddleware(this.epics.combineEpics())];
  // }
}

export interface State {
  localization: LocalizationState;
}
